import appEventBus, { API_REMOVE_ACTIVE_AD_GROUP_HEADER, API_ADD_ACTIVE_AD_GROUP_HEADER } from 'config/appEventBus';
import actionTypes from './actionTypes';

export const setUser = (cognitoUserData) => {
  return {
    type: actionTypes.SET_USER,
    payload: cognitoUserData,
  };
};

export const setActiveUserADGroup = (groupName) => {
  appEventBus.emit(API_ADD_ACTIVE_AD_GROUP_HEADER, groupName);

  return {
    type: actionTypes.SET_ACTIVE_USER_AD_GROUP,
    payload: groupName,
  };
};

export const resetActiveUserADGroup = () => {
  appEventBus.emit(API_REMOVE_ACTIVE_AD_GROUP_HEADER);

  return {
    type: actionTypes.RESET_ACTIVE_USER_AD_GROUP,
  };
};

export const signOut = () => {
  return {
    type: actionTypes.SIGN_OUT,
  };
};

export const hideGlobalNavigation = () => ({
  type: actionTypes.HIDE_GLOBAL_NAVIGATION,
});

export const showGlobalNavigation = () => ({
  type: actionTypes.SHOW_GLOBAL_NAVIGATION,
});

export const addNotification = (notification) => ({
  type: actionTypes.ADD_NOTIFICATION,
  payload: notification,
});

export const clearNotification = (id) => ({
  type: actionTypes.CLEAR_NOTIFICATION,
  payload: { id },
});

export const checkAttachmentsLimit = (attachments = [], isEmail) => async (dispatch, getState) => {
  const stateAttachments = getState().clientingModule.conversation.attachments;
  const totalLength = attachments.length + stateAttachments.length;

  if (!isEmail && totalLength > 10) {
    dispatch(
      addNotification({
        id: `error-${Date.now()}`,
        message: '10 attachment limit exceeded',
        type: 'error',
      }),
    );

    return true;
  }

  return false;
};
